<template>
  <div class="t-review">
    <TAvatar
      :img-prop="imgProp"
      size="md"
      variant="image"
      :title="title"
      :subtitle="subtitle"
      class="mb-1"
    />

    <TStars class="mb-2" :stars="stars" />
    <UButton
      v-if="showCottageLink"
      variant="link"
      size="lg"
      color="neutral"
      v-bind="cottageButtonProps"
    >
      {{ textLeading }}
    </UButton>

    <TText classes="mb-2" clamp="clamp3">
      {{ removeCarriageReturns(text) }}
    </TText>
    <UButton
      v-if="showReviewLink"
      variant="link"
      size="sm"
      color="neutral"
      v-bind="reviewButtonProps"
    >
      {{ linkText }}
    </UButton>
  </div>
</template>

<script setup lang="ts">
import type { TLazyimg_Props } from '~~/modules/design-system/components/t-lazyimg/constants/types'
import removeCarriageReturns from '~/utils/removeCarriageReturns'

export type reviewVariant =
  | 'default'
  | 'no-link'
  | 'no-review-link'
  | 'seo-listing'
export interface Props {
  title?: string
  subtitle?: string
  imgUrl?: string
  stars?: number
  text?: string
  textLeading?: string
  linkCottage?: string
  linkText?: string
  linkHref?: string
  variant?: reviewVariant
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  subtitle: '',
  imgUrl: '',
  stars: 0,
  text: '',
  textLeading: '',
  linkText: '',
  linkHref: '',
  variant: 'default',
})

const showCottageLink =
  ['default', 'seo-listing', 'no-review-link'].includes(props.variant) &&
  !!props.linkCottage &&
  !!props.textLeading

const showReviewLink =
  ['default', 'seo-listing', 'no-link'].includes(props.variant) &&
  !!props.linkHref &&
  !!props.linkText

const isSeoListing = props.variant === 'seo-listing'

const handleCottageClick = () => {
  if (props.linkCottage) {
    navigateTo(props.linkCottage, { external: true })
  }
}
const cottageButtonProps = isSeoListing
  ? { onClick: handleCottageClick }
  : { external: true, to: props.linkCottage }

const handleReviewClick = () => {
  if (props.linkHref) {
    navigateTo(props.linkHref, { external: true })
  }
}
const reviewButtonProps = isSeoListing
  ? { onClick: handleReviewClick }
  : { external: true, to: props.linkHref }

const imgProp: TLazyimg_Props = {
  src: props.imgUrl as string,
  alt: props.title,
}
</script>
